// 正式环境配置
export default {
  ENV_TYPE: 'production',
  BASE_URL: 'http://dfxdapi.rolmex.com.cn', // api请求地址
}
